(ns ycweb.app.admin.users.users
  (:require
   [rum.core :as rum]
   [ycweb.components.common :as cmn]
   [ycweb.components.datatables.datatables :as datatables]
   [ycweb.components.flow :as flow]
   [ycweb.components.headings :as headings]
   [ycweb.components.transitions :as t]
   [ycweb.util.comms :as comms]))

(defn data-source-parameters [app-atom]
  (let [process-atom (cmn/process-cursor app-atom)
        user (cmn/curact process-atom :user)]
    {:user-id (:id user)}))

(def user-grid-fns
  {:data-source-fns
   {:user-fn (partial data-source-parameters)}})

(def keep-aside-data-table-config
  {:table-name :keep-aside-data
   :row-id :ent/uuid
   :data-source
   {:end-point :admin.user.keepaside/list
    :parameter-fn :user-fn}
   :options
   {:order :asc
    :sort-title "Request No."}
   :select? true
   :column-defs
   [{:key :order-idx
     :title "Request No."}
    {:key :keep-aside-order/dateadded
     :title "Date Started"}
    {:key :ent/display-name
     :title "Product"}
    {:key :keep-aside-item/features
     :title "Features"}
    {:key :keep-aside-item/code
     :title "Product Code"}
    {:key :keep-aside-item/status
     :title "Item Status"}
    {:key :keep-aside-order/status
     :title "Request Status"}
    {:key :keep-aside-order/date-expires
     :title "Expiry Date"}
    {:key :keep-aside-order/date-collection-email
     :title "Ready Emailed"}
    {:key :keep-aside-order/store
     :title "Store"}
    {:key :keep-aside-order/stock-source
     :title "Stock Source"}]})

(rum/defc keepaside-user-table < rum/reactive [app-atom]
  [:div
   [:div.u-min-height-160
    (headings/heading "Keep Aside requests" {:type :h2 :size :default})
    (datatables/table app-atom :keep-aside-data user-grid-fns)]])

(def user-shopcarts-table-config
  {:table-name :user-shopcarts
   :row-id :idx
   :data-source
   {:end-point :admin.user.shopcarts/list
    :parameter-fn :user-fn}
   :options
   {:order :desc
    :sort-title "Date started"
    :paging? true
    :pagination {:page-size 10}}
   :column-defs
   [{:key :cart-link
     :title "Cart"
     :type :link
     :options {:redirect? true}}
    {:key :status
     :title "Status"
     :searchable :select}
    {:key :source
     :title "Source"
     :searchable :select}
    {:key :dateadded
     :type :date
     :title "Date started"}
    {:key :dateupdated
     :type :date
     :title "Last updated"}
    {:key :item_count
     :type :number
     :title "Items"}
    {:key :total
     :type :tocurrency
     :title "Cart value"}
    {:key :email
     :title "E-mail"}
    {:key :active
     :title "Active"}]})

(rum/defc user-shopcarts < rum/reactive [app-atom]
  [:div
   [:div.u-min-height-160.u-margin-top-24
    (headings/heading "Carts" {:type :h2 :size :default})
    [:p.text-small
     "Carts in the new cart system. \"Active\" is the cart the website resumes for this customer."]
    (datatables/table app-atom :user-shopcarts user-grid-fns)]])

(def user-subscription-table-config
  {:table-name :user-subscription-history
   :row-id :idx
   :data-source
   {:end-point :admin.user.subscription/history
    :parameter-fn :user-fn}
   :options
   {:order :asc
    :sort-title "Date"}
   :column-defs
   [{:key :interest
     :title "Interest"
     :searchable :select}
    {:key :source
     :title "Source"}
    {:key :email
     :title "E-mail"}
    {:key :datetime
     :type :date
     :title "Date"}
    {:key :action
     :title "Action Taken"}]})

(rum/defc user-newsletter-subscriptions < rum/reactive [app-atom]
  (let [process-atom (cmn/process-cursor app-atom)
        user (cmn/curact process-atom :user)]
    [:div
     [:div.u-min-height-160.u-margin-top-24
      (headings/heading "Newsletter subscription history" {:type :h2 :size :default})
      [:div
       [:p.text-small
        (cond
          (:unsubscriber user)
          [:b "This user has been found in the unsubscribers table"]

          :else
          "This user is not in the unsubscribers table.")]]
      (datatables/table app-atom :user-subscription-history user-grid-fns)]]))

(defmethod t/transition-open :admin.useradmin/view [app-atom _ params]
  (let [process-atom (cmn/process-cursor app-atom)
        user-atom (rum/cursor process-atom :user)]
    (swap! user-atom assoc :id (:id params))
    (comms/send :admin.user.list/unsubscribers {:user-id (:id params)})
    (datatables/initiate app-atom user-shopcarts-table-config user-grid-fns)
    (datatables/initiate app-atom user-subscription-table-config user-grid-fns)
    (datatables/initiate app-atom keep-aside-data-table-config user-grid-fns)))

(defmethod comms/receive :admin.user.list/unsubscribers [app-atom {:keys [user]}]
  (let [process-atom (cmn/process-cursor app-atom)]
    (swap! process-atom assoc :user user)))

(defmethod comms/receive :admin.user.shopcarts/list [app-atom {:keys [rows]}]
  (datatables/post-comms app-atom
    :user-shopcarts
    {:rows rows}))

(defmethod comms/receive :admin.user.subscription/history [app-atom {:keys [rows]}]
  (datatables/post-comms app-atom
    :user-subscription-history
    {:rows rows}))

(defmethod flow/render-screen :admin.useradmin/view [app-atom _]
  [:div
   (user-shopcarts app-atom)
   (user-newsletter-subscriptions app-atom)
   (keepaside-user-table app-atom)])

(defmethod comms/receive :admin.user.keepaside/list [app-atom e]
  (datatables/post-comms app-atom :keep-aside-data {:rows (:items e)}))
